import IconConsult from 'Src/assets/icons/icon-consult.svg';
import IconHealth from 'Src/assets/icons/icon-health.svg';
import IconNutrition from 'Src/assets/icons/icon-nutrition.svg';
import IconCare from 'Src/assets/icons/icon-care.svg';
import IconTraining from 'Src/assets/icons/icon-training.svg';
import IconOther from 'Src/assets/icons/icon-other.svg';
export const RubricIconBySlug: Record<string, React.ReactNode> = {
    consult: <IconConsult />,
    health: <IconHealth />,
    nutrition: <IconNutrition />,
    care: <IconCare />,
    training: <IconTraining />,
    other: <IconOther />,
};
